/**
 * Which of the main screen's sections are folded away, per browser: a way of
 * arranging this screen, not a fact about the ledger, so it lives in
 * localStorage (`okane.sections`) and not in the database — like the help's
 * "seen" mark. Missing or unreadable storage just means everything is shown.
 */
import { reactive } from 'vue'

const KEY = 'okane.sections'

function read() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? '{}')
    return saved && typeof saved === 'object' ? saved : {}
  } catch {
    return {}
  }
}

/** Section id → true while it is hidden. */
export const hiddenSections = reactive(read())

export const isHidden = (id) => !!hiddenSections[id]

export function toggleSection(id) {
  if (hiddenSections[id]) delete hiddenSections[id]
  else hiddenSections[id] = true
  try {
    localStorage.setItem(KEY, JSON.stringify(hiddenSections))
  } catch {
    // Folded for as long as the page is open.
  }
}
